import { Box, Typography } from '@mui/material';
import { theme } from 'config/theme';
import CheckLineIcon from 'remixicon-react/CheckLineIcon';
import TimeLineIcon from 'remixicon-react/TimeLineIcon';
import { InsightSummaryStatusType } from '../queries/useInsightsSummaryQuery';
import { styled } from '@mui/material/styles';

export const InsightStatusChip = styled(Box, { label: 'InsightStatusChip' })({
  width: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  padding: '4px 16px',
  borderRadius: 20,
  '&.published': {
    backgroundColor: theme.palette.custom.iceberg,
  },
  '&.review-pending': {
    backgroundColor: theme.palette.custom.softPeach,
  },
});

export const InsightStatusText = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.dark,
  fontSize: '14px !important',
  marginLeft: 8,
}));

export const renderInsightStatusOptionLabel = (insightStatus: InsightSummaryStatusType) => {
  switch (insightStatus) {
    case InsightSummaryStatusType.REVIEW_PENDING: {
      return (
        <InsightStatusChip className="review-pending">
          <TimeLineIcon size={20} color={theme.palette.custom.tuna} />
          <InsightStatusText>Review Pending</InsightStatusText>
        </InsightStatusChip>
      );
    }

    case InsightSummaryStatusType.PUBLISHED: {
      return (
        <InsightStatusChip className="published">
          <CheckLineIcon size={20} color={theme.palette.custom.tuna} />
          <InsightStatusText>Published</InsightStatusText>
        </InsightStatusChip>
      );
    }

    default:
      return insightStatus;
  }
};
